import React from 'react';
import { Field, useFormikContext } from 'formik';

import { FormErrorUI, FormLabelUI, AutoCompleteSelectUI, DatePickerUI, InputUI } from '../Interface';
import useParam from '../../context/ParamContext';
import { getProjectOrderNumberName } from '../../utils/getProjectOrderNumberName';

const OtherExpenseFields = ({ viewField, selectedValues, autocompleteOptions, autoCompleteData }) => {
  const { params } = useParam();
  const { values, validateField, setFieldValue, errors } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 gap-y-2 mx-4 mb-5">
      <div className="col-span-4 md:col-span-1">
        <Field
          type="date"
          name="date"
          component={DatePickerUI}
          value={values.date}
          fullWidth
          disabled={viewField}
          label={<FormLabelUI text="Dátum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.date} />}
          onChange={(date) => {
            setFieldValue('date', date).then(() => {
              validateField('date');
            });
          }}
          InputLabelProps={{ shrink: values.date !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="costAndRevenueTypeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Költség fajta" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.costAndRevenueTypeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('costAndRevenueTypeId', newVal?.value ?? null).then(() => {
              validateField('costAndRevenueTypeId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.costAndRevenueTypeId !== '' }}
          selectedValue={values.costAndRevenueTypeId}
          selectedLabelValue={selectedValues?.costAndRevenueType?.name}
          dataset={autocompleteOptions.costAndRevenue}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="costCenterCode"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Költséghely" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.costCenterCode} />}
          onChange={(_e, newVal) => {
            setFieldValue('costCenterCode', newVal?.value ?? null).then(() => {
              validateField('costCenterCode');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.costCenterCode !== '' }}
          selectedValue={values.costCenterCode}
          selectedLabelValue={selectedValues?.costCenter?.name}
          dataset={autocompleteOptions.costCenter}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="projectId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Projekt" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.projectId} />}
          onChange={(_e, newVal) => {
            const findedProject = autoCompleteData?.project.find((item) => item.projectId === newVal?.value);
            if (findedProject) {
              setFieldValue('projectOrderNumber', findedProject.orderNumber || '');
            } else {
              setFieldValue('projectOrderNumber', '');
            }

            setFieldValue('projectId', newVal?.value ?? null).then(() => {
              validateField('projectId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.projectId !== '' }}
          selectedValue={values.projectId}
          selectedLabelValue={selectedValues?.project?.projectName}
          dataset={autocompleteOptions.project}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="projectOrderNumber"
          component={InputUI}
          fullWidth
          label={<FormLabelUI text={getProjectOrderNumberName(params)} />}
          variant="standard"
          helperText={<FormErrorUI message={errors.projectOrderNumber} />}
          disabled={true}
          InputLabelProps={{ shrink: values.projectOrderNumber !== '' }}
          value={values.projectOrderNumber}
        />
      </div>
    </div>
  );
};

export default OtherExpenseFields;
